import { render } from "./CustomSlider.vue?vue&type=template&id=5e0c6e4a"
import script from "./CustomSlider.vue?vue&type=script&lang=js"
export * from "./CustomSlider.vue?vue&type=script&lang=js"

import "./CustomSlider.vue?vue&type=style&index=0&id=5e0c6e4a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__